/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Body1Inputs */

const en_to_yaml_body1 = /** @type {(inputs: To_Yaml_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML is a superset of JSON, so every JSON document has a YAML equivalent and the conversion never loses data. What it does change is how the values are written, and YAML has considerably more ways to write the same value than JSON does. Most of the interesting behaviour in this converter is about picking a form that reads back as the value you started with.`)
};

const ko_to_yaml_body1 = /** @type {(inputs: To_Yaml_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML은 JSON의 상위집합이므로 모든 JSON 문서에는 대응하는 YAML이 있고 변환에서 데이터가 손실되지 않습니다. 바뀌는 것은 값이 표기되는 방식이며, YAML은 같은 값을 표기하는 방법이 JSON보다 훨씬 많습니다. 이 변환기에서 흥미로운 동작은 대부분 시작한 값 그대로 다시 읽히는 표기를 고르는 일에 관한 것입니다.`)
};

const ja_to_yaml_body1 = /** @type {(inputs: To_Yaml_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML は JSON の上位集合なので、すべての JSON 文書には対応する YAML があり、変換でデータが失われることはありません。変わるのは値の書き方で、YAML には同じ値を書く方法が JSON よりずっと多くあります。この変換器で面白い挙動のほとんどは、始めた値のまま読み戻せる書き方を選ぶことに関わります。`)
};

/**
* | output |
* | --- |
* | "YAML is a superset of JSON, so every JSON document has a YAML equivalent and the conversion never loses data. What it does change is how the values are writt..." |
*
* @param {To_Yaml_Body1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_body1 = /** @type {((inputs?: To_Yaml_Body1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Body1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_body1(inputs)
	if (locale === "ko") return ko_to_yaml_body1(inputs)
	return ja_to_yaml_body1(inputs)
});